module.exports = __webpack_public_path__ + "a347b1db5909af7d5d7e55b297c26510.fbx";